/* unplugin-vue-components disabled */import script from "./TopHerder.vue?vue&type=script&setup=true&lang=js"
export * from "./TopHerder.vue?vue&type=script&setup=true&lang=js"

import "./TopHerder.vue?vue&type=style&index=0&id=2f0f200b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0f200b"]])

export default __exports__